import React, {  useCallback, useState } from "react";
import { BsFillTrashFill, BsThreeDotsVertical } from "react-icons/bs";
import { FiEdit3 } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import useApi from "../../hooks/useApi";
import Modal from "../../Korbantech/components/Modal";
import { Trail } from "../../types/Trail";
import { ContextMenu } from "../ContextMenu";

export const TrailsAdminCard = ({ trail }: Props) => {
    const navigate = useNavigate();
    const api = useApi();
    const [contextIsOpen, setContextIsOpen] = useState<boolean>(false);
    const [modalOPen, setModalOpen] = useState<boolean>(false);

    const handleDelete = useCallback(async () => {
        await api
            .delete(`/admin/trails/${trail.id}`)
            .then((res) => {
                window.location.reload();
            })
            .catch(console.log);
    }, [api, trail]);

    return (
        <div className="bg-white border-2 rounded-md p-3 ">
            <div className="flex justify-between">
                <div className="text-lg font-semibold">{trail.name}</div>
                <div className="">
                    <BsThreeDotsVertical
                        className="text-lg"
                        onClick={() => setContextIsOpen(true)}
                    />
                    <div className="relative">
                    <ContextMenu
                        open={contextIsOpen}
                        close={() => setContextIsOpen(false)}
                    >
                        <div
                            className="flex items-center cursor-pointer"
                            onClick={() =>
                                navigate(`/admin/trilha/${trail.id}`)
                            }
                        >
                            <FiEdit3 className="mr-1" />
                            Editar
                        </div>
                        <div
                            className="flex items-center cursor-pointer"
                            onClick={() => setModalOpen(true)}
                        >
                            <BsFillTrashFill className="mr-1 text-red-500" />
                            Deletar
                        </div>
                    </ContextMenu>
                    </div>
                </div>
            </div>
            <Modal
                open={modalOPen}
                onClickCloseButton={() => setModalOpen(false)}
            >
                <strong>Deseja mesmo deletar o item :</strong>
                {trail.name}
                <div className="flex justify-between gap-x-2">
                    <button
                        className="bg-primary-dark mt-3 py-1 px-2 rounded-md"
                        onClick={() => setModalOpen(false)}
                    >
                        Cancelar
                    </button>
                    <button
                        className="bg-red-500 mt-3 py-1 px-2 rounded-md text-white"
                        onClick={() => handleDelete()}
                    >
                        Confirmar e deletar
                    </button>
                </div>
            </Modal>
        </div>
    );
};

interface Props {
    trail: Trail;
}
